// extracted by mini-css-extract-plugin
export default {"multiple-inputs":"formBody_multiple-inputs__loPk+","multiple-inputs__item":"formBody_multiple-inputs__item__ixDd0"};